import { Component, Input, ViewChild } from "@angular/core";
import { Navigator } from 'src/app/services/routing/navigator';
import { ConfigService } from "src/app/services/config/config.service";
import { IPromotion } from "src/app/interfaces/player-dashboard.interface";
import { Platform } from "@ionic/angular";

@Component({
    selector: 'app-promotions-section',
    templateUrl: './promotions-section.component.html',
    styleUrls: ['./promotions-section.component.scss'],
})
export class PromotionsSectionComponent {
    @Input() set promotionsList (val: Array<IPromotion>) {
        this.promotions = val.filter(this.filteredBanners).map((item) => {
            item.banner_image_large = this.config.getCampaignBanerImgUrl(item).lg;
            item.banner_image_small = this.config.getCampaignBanerImgUrl(item).sm;
            item.banner_image_medium = this.config.getCampaignBanerImgUrl(item).md;
            return item;
        });
    }

    public isMobileWeb:boolean = false
    public promotions: Array<IPromotion>;


  

    constructor (
        private navigator: Navigator,
        public config: ConfigService,
        private platform: Platform
    ) {this.isMobileWeb = this.platform.is('mobileweb');}

    private filteredBanners = (banner: IPromotion) => {
        return !!~~banner.show_banner_flag;
    }

  
   

    public moreInfo(promo: IPromotion) {
        this.navigator.openPopover(
            'PromotionDetailsPopoverComponent',
            promo,
            'standard-popover',
            true,
            true,
            true
          );
    }
}